<template>
    <b-modal
            v-model="show"
            title="Редактирование сотрудника"
            @hide="close(false)"
    >
        <div>
            <b-container fluid>
                <b-row no-gutters class="mb-2">
                    <b-col>
                        <label class="custom-input-label">ФИО</label>
                        <b-input
                                placeholder="Иванов Иван Иванович"
                                v-model="webUserModel.userName"
                                required
                                :state="errors.findIndex(x=>x.key='orgName')!=-1?editModel.orgName!=null?true:false:null"
                        />
                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-2">
                    <b-col>
                        <label class="custom-input-label">Телефон</label>

                        <b-input
                                placeholder="9876543210"
                                v-model="webUserModel.phoneNumber"
                                :formatter="formatPhone"
                                class="phone"
                                :state="errors.findIndex(x=>x.key='phoneNumber')!=-1?webUserModel.phoneNumber!=null&&webUserModel.phoneNumber!=''?true:false:null"
                        /><label class="phone" style="bottom:5px" data-fon="+7">&nbsp;</label>

                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-1">
                    <b-col>
                        <label class="custom-input-label">Организация</label>
                        <div class="disabled-filled-option">{{webUserModel.organization}}</div>
                    </b-col>
                </b-row>
                <b-row no-gutters>
                    <b-col>
                        <label class="custom-input-label">Уровень доступа</label>
                        <b-select
                                :options="accessLevels"
                                value-field="id"
                                text-field="name"
                                rows="6"
                                v-model="webUserModel.webUserAccessLevelId"
                                :state="errors.findIndex(x=>x.key='webUserAccessLevelId')!=-1?webUserModel.webUserAccessLevelId!=null?true:false:null"
                        />
                    </b-col>
                </b-row>
                <b-row no-gutters>
                    <b-col>
                        <label class="custom-input-label">Филиал</label>
                        <b-select
                                :options="orgBranches"
                                value-field="id"
                                text-field="address"
                                rows="6"
                                v-model="webUserModel.orgGeoInfoId"
                                :state="errors.findIndex(x=>x.key='orgGeoInfoId')!=-1?webUserModel.orgGeoInfoId!=null?true:false:null"
                        />
                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-2">
                    <b-col>
                        <label class="custom-input-label">Логин</label>
                        <div class="disabled-filled-option">{{webUserModel.account}}</div>
                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-2">
                    <b-col>
                        <label class="custom-input-label">Email</label>
                        <b-input

                                v-model="webUserModel.eMail"
                                required
                                :state="errors.findIndex(x=>x.key='eMail')!=-1?webUserModel.eMail!=null?true:false:null"
                        />
                    </b-col>
                </b-row>

            </b-container>

        </div>

        <template v-slot:modal-footer>
            <div class="w-100">
                <v-row no-gutters  justify="space-between">
                    <v-col cols="auto" class="mr-2">
                        <v-btn
                                outlined
                                color="var(--color-red)"
                                size="sm"
                                @click="deleteItem"
                        >
                            <v-icon>mdi-delete</v-icon> Удалить
                        </v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto" class="mr-2">
                        <v-btn
                                color="var(--color-blue)"
                                dark
                                size="sm"
                                @click="onSave"
                        >
                            Сохранить
                        </v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn
                                class="cancel-btn"
                                outlined
                                color="var(--color-3)"
                                size="sm"
                                @click="close(false)"
                        >
                            Отмена
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </template>
    </b-modal>
</template>

<script>
    import mapper from 'automapper'
    import axios from 'axios'
    export default {
        name: "EditStaffModal",
        props:['show', 'item', "organization"],
        data(){
            return{
                errors:[],
                correctLogin:null,
                webUserModel:{
                    id: null,
                    account: null,
                    userName: null,
                    identityId:null,
                    eMail: null,
                    phoneNumber: null,
                    isAdmin: false,
                    password: null,
                    isActive: true,
                    organizationId: null,
                    orgGeoInfoId:null,
                    organization: null,
                    webUserLogo: null,
                    webUserAccessLevelId:null
                },
                identityModel: {
                    login: null,
                    email: null,
                    phoneNumber: null,
                    password: null,
                    userName: null,
                    isClient: true,
                    isAdministrator: false,
                    organizationId: null,
                    webSite: ''
                },

            }
        },
        created(){
            this.$store.dispatch("Partners/getUserAccessLevels").catch(error=>{
                this.$bvToast.toast(error.response.data != null ? error.response.data : error, {
                    title: `Ошибка получения уровней доступа!`,
                    variant: "danger",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                })
            })

            mapper.createMap("editWebUserModel", "identityModel")
                .forMember('login', function () {
                    this.mapFrom('account')
                })
                .forMember('isAdministrator', function () {
                    this.mapFrom('isAdmin')
                })
                .forMember('isClient', function () {
                    return false
                })
                .forMember('webSite', function () {
                    return null
                })
                .forMember('email', function () {
                    this.mapFrom('eMail')
                })

        },
        computed:{
            accessLevels(){
                return this.$store.state.Partners.accessLevels
            },

            orgBranches(){
                return this.$store.state.Partners.partnerBranches
            },

            curWebUser(){
                return this.$store.state.userData.webUser
            },

        },
        methods:{
            setItems(){
                for (let key in this.webUserModel){
                    if(this.item.hasOwnProperty(key)){
                        this.webUserModel[key]=this.item[key]
                    }
                }
            },

            formatPhone(value, e){
                //оставляем только цифры
                value= value.replace(/\D/,"")
                value=value.replace(/^[0-8]/,"")
                return value.substr(0,10);
            },

            validateModel() {
                var noError = true;
                this.errors = [];
                if (this.webUserModel.organizationId == null) {
                    this.errors.push({key: "organizationId", mes: "Необходимо выбрать организацию!"});
                    noError = false;
                }
                if (this.webUserModel.userName == null || this.webUserModel.userName == '') {
                    this.errors.push({key: "userName", mes: "Необходимо указать ФИО!"});
                    noError = false;
                }

                if (this.webUserModel.account == null || this.webUserModel.account == '') {
                    this.errors.push({key: "account", mes: "Необходимо указать логин!"});
                    noError = false;
                }

                if (this.webUserModel.phoneNumber == null || this.webUserModel.phoneNumber == '') {
                    this.errors.push({key: "phoneNumber", mes: "Необходимо указать номер телефона!"});
                    noError = false;
                }

                if (this.webUserModel.eMail == null || this.webUserModel.eMail == '') {
                    this.errors.push({key: "eMail", mes: "Необходимо указать Email!"});
                    noError = false;
                }

                return noError;

            },

            async onSave() {
                const vm = this;
                //проверяем на заполнение полей
                if (this.validateModel() == true) {
                    var curUser = this.$store.state.userData.curUser;

                    //1) приводим модель к идентити
                    mapper.map("editWebUserModel", "identityModel", this.webUserModel, this.identityModel)

                    var isOk = false;
                    //обновляем пользователя на идентити
                    await axios.post(`${vm.$root.identityURL}/api/UserAccount/UpdateInfo`, vm.identityModel, {headers: {Authorization: "Bearer " + curUser.access_token}})
                        .then(response => isOk = true)
                        .catch(error => {
                            this.$bvToast.toast(error.response.data != null ? error.response.data : error, {
                                title: `Ошибка!`,
                                variant: "danger",
                                toaster: 'b-toaster-bottom-right',
                                autoHideDelay: 3000,
                                solid: true
                            })
                        });
                    //если пользователь изменен на идентити
                    if (isOk == true) {
                        //загружаем аватар на сервер
                        if (this.userLogoModel != null) {
                            var imgId = null;
                            const imgData = new FormData();
                            imgData.append('files', this.userLogoModel);
                            await axios.post(`${vm.$root.baseUrl}:8085/api/FileUpload`, imgData)
                                .then(response => imgId = response.data[0])
                                .catch(error => {
                                    console.log(error)
                                });
                            if (imgId != null)
                                this.webUserModel.webUserLogo = imgId;
                        }

                        this.$store.dispatch('Clients/editWebUser', vm.webUserModel).then(() => {
                                this.$bvToast.toast("Пользователь успешно обновлен", {
                                    variant: "success",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            this.close(true)
                            }
                        ).catch((err) => {
                            this.$bvToast.toast(err, {
                                title: `Ошибка!`,
                                variant: "danger",
                                toaster: 'b-toaster-bottom-right',
                                autoHideDelay: 3000,
                                solid: true
                            })
                        });
                    }

                }
                else {
                    this.errors.forEach(err => {
                        this.$bvToast.toast(err.mes, {
                            title: `Не все поля заполнены!`,
                            variant: "warning",
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 7000,
                            solid: true
                        })
                    })
                }
            },


            close(isSave){
                this.$emit("close", isSave)
            },

            async deleteItem() {
                const vm = this;
                this.$bvModal.msgBoxConfirm('Вы действительно хотите удалить запись?', {
                    title: 'Подтверждение',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Удалить',
                    cancelTitle: 'Отмена',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                    .then(value => {
                        if (value == true) {
                            axios.delete(`${vm.$root.identityURL}/api/useraccount/Delete?login=` + this.webUserModel.account).then(res => {
                                //после удаления на идентити, удаляем из бд
                                vm.$store.dispatch("Clients/deleteWebUser", vm.webUserModel.id).then(() => {
                                    vm.$bvToast.toast("Пользователь успешно удален", {
                                        variant: "success",
                                        toaster: 'b-toaster-bottom-right',
                                        autoHideDelay: 3000,
                                        solid: true
                                    })
                                    vm.close(true)

                                }).catch(err => {
                                    vm.$bvToast.toast(err.message, {
                                        title: `Ошибка удаления пользователя!`,
                                        variant: "danger",
                                        toaster: 'b-toaster-bottom-right',
                                        autoHideDelay: 3000,
                                        solid: true
                                    })
                                });
                            })
                                .catch(error => {
                                    vm.$bvToast.toast(error.response.data ? error.response.data : error, {
                                        title: `Ошибка!`,
                                        variant: "danger",
                                        toaster: 'b-toaster-bottom-right',
                                        autoHideDelay: 3000,
                                        solid: true
                                    })
                                });
                        }

                    })
                    .catch(err => {

                    })
            },

        },
        watch:{

            show(value){
                if(value==true){
                    this.errors=[]
                    this.setItems()

                        this.webUserModel.organizationId=this.organization.id;
                        this.$store.dispatch("Partners/getPartnerBranches", this.organization.id).catch(error=>{
                            this.$bvToast.toast(error.response.data != null ? error.response.data : error, {
                                title: `Ошибка получения списка филиалов!`,
                                variant: "danger",
                                toaster: 'b-toaster-bottom-right',
                                autoHideDelay: 3000,
                                solid: true
                            })
                        })

                }
            }
        }

    }
</script>

<style scoped>

</style>